/**
 * Das Suchfenster (F-18) - einmal in der Huelle, von jeder Seite aus
 * erreichbar: Such-Knopf in Navigation und Kopfzeile, Strg+K (bzw. Cmd+K),
 * Klick auf ein Schlagwort.
 */
import { useEffect } from 'react';

import { Dialog } from '@/ui/primitives/Dialog';
import { SuchPanel } from '@/modules/suche/SuchPanel';
import { useSuche } from '@/modules/suche/sucheStore';

export function SuchDialogHost() {
  const offen = useSuche((s) => s.offen);
  const start = useSuche((s) => s.start);
  const schliessen = useSuche((s) => s.schliessen);

  useEffect(() => {
    function taste(e: KeyboardEvent) {
      if ((e.ctrlKey || e.metaKey) && !e.altKey && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        const s = useSuche.getState();
        if (s.offen) s.schliessen();
        else s.oeffnen();
      }
    }
    window.addEventListener('keydown', taste);
    return () => window.removeEventListener('keydown', taste);
  }, []);

  return (
    <Dialog open={offen} onClose={schliessen} title="Suche" className="max-h-[85vh] w-[min(44rem,calc(100vw-2rem))] overflow-y-auto">
      <SuchPanel key={start} start={start} autoFocus onGewaehlt={schliessen} />
    </Dialog>
  );
}
